export const standardColors = {
  primaryBackground: '#1d2941',
  onImageBackground: '#FFFFFF',
  onIconsAndTextButtons: '#1b2230',
  onIconsAndTextButtonsVariant: '#1b2230',
  secondaryBackground: '#1b2230',
  selectedAndDetailBackground: '#2f4472',
  borderLine: '#2c5e87',
  placeholderText: '#175c97',
  menuBackground: '#dce1e4',
  currentStep: '#dce1e4',
  onSecondaryAndDetailBackground: '#FFFFFF',
  hoverMenuBackground: '#fafafa',
  mainFocused: '#0089ff',
  highlight: '#ff9700',
  tradingDown: '#ff9700',
  tradingUp: '#ff9700',
  off: '#3c4a6d',
  lower: '#175c97',
  footerBackground: '#1D2941',
  onFooterBackground: '#FFFFFF',
  popupWindow: '#DCE1E4',
  popupWindowTitle: '#1D2941',
  iconsOnFooterBackground: '#0089ff',
  primaryDisabledBackground: '#2b3c5d',
  secondaryDisabledBackground: '#1b2230',
  primaryDisabledText: '#192744',
  secondaryDisabledText: '#203f6c',
  scrollOnDetailBackground: '#213356',
  scrollOnPrimaryBackground: '#263451',
  infoBackground: '#253a69',
  nextStep: '#32446b',
  previousStep: '#445f96',
  iconsOnMenuBackground: '#90a8b6',
  mainFocusedSoothing: '#123655',
  highlightSoothing: '#323340',
  pillBorder: '#8ecbff',
  pillBackgroundGloomy: '#5f94c2',
  pillBackgroundLight: '#1c3448',
  dividerOnPrimaryBackground: '#395182',
  label: '#596f99',
  homePageBackground: '#222a3a',
  onHomePageBackground: '#FFFFFF',
  refreshButton: '#DCE1E4',
  dashboardDivider: '#3C5CA2',
  star: '#ffcf06',
  up: '#3fc721',
  down: '#f52b2b',
  inert: '#6ec4e8',
  scrollOnInfoBackground: '#405482',
  actionBar: '#394a6d',
  onInfoBackground: '#FFFFFF',
  onPrimaryBackground: '#FFFFFF',
  lockedBackground: 'rgba(20, 48, 103, 0.45)',
  hoverHighlight: '#FFAF3B',
  variantOnInfoBackground: '#ffffff',
  variantOnPrimaryBackground: '#ffffff',
  graphBackground: '#17243f',
  disabledAndHoverOnInfoBackground: '#445f96',
  disabledOnPrimaryBackground: '#395182',
  iconsSelectedOnMenu: '#FF9700',
  selectedBarOnMenu: '#FF9700',
  selectedTextButtonMenu: '#0089FF',
  newsBackground: '#203257',
};
